import React, { Component } from "react";
import AuthService from "./AuthService";

const AuthContext = React.createContext();

export const AuthConsumer = AuthContext.Consumer;
export const Service = new AuthService();
export class AuthProvider extends Component {
  authService;
  constructor(props) {
    super(props);
    this.authService = new AuthService();
  }

  render() {
    return <AuthContext.Provider value={this.authService}>{this.props.children}</AuthContext.Provider>;
  }
}